import {
  MotionBox as Box,
  MotionFlex as Flex,
  viewAppearDefault,
  staggeredAppear,
} from "utils/motion";
import { SimpleGrid } from "@chakra-ui/react";
import Text from "components/base/Text";
import Trans from "components/base/Trans";
import Container from "components/base/Container";
import Image from "components/base/Image";

const Pill = ({ children }) => (
  <Flex py="4px" align="center">
    <Image
      src="/images/early-careers/icon-star.png"
      h="18px"
      w="18px"
      mr="16px"
    />
    <Text type="p_lg" color="white">
      {children}
    </Text>
  </Flex>
);

export default function PillsSection({
  title,
  subtitle,
  subtitleType,
  pills,
  inverted,
  bg,
  children,
}) {
  const textColor = inverted ? "black.900" : "white";

  return (
    <Box
      width="100%"
      bg={bg || (inverted ? "white" : "black.900")}
      px={[6, null, 20]}
    >
      <Container as="section" px={0}>
        <Box>
          <Text type="title_md" color="primary" mb="xs">
            {title}
          </Text>
          <Text type={subtitleType || "headline_md"} color={textColor}>
            {subtitle}
          </Text>
        </Box>
        <Box
          variants={staggeredAppear}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.1 }}
          mt="xl"
          bg="gray.600"
          px={[6, 12, null, 12]}
          py={[6, null, 24]}
          color="primary"
          borderLeft="7px solid"
          borderColor="primary"
        >
          <SimpleGrid
            columns={[1, 1, 1, 2, 3]}
            spacing={["8px", null, null, "20px"]}
          >
            {pills.map((category, index) => (
              <Box key={index} variants={viewAppearDefault}>
                <Pill isLast={pills.length - 1 === index}>
                  <Trans id={category} />
                </Pill>
              </Box>
            ))}
          </SimpleGrid>
        </Box>
        {children}
      </Container>
    </Box>
  );
}
